<div class="modal-header" id="request-version-update-modal-title">
    <h3 class="modal-title" id="modal-title">{{ 'APP_SERVICE_WORKER_UPDATE_TITLE' | translate }}</h3>
</div>
<div class="modal-body text-center">
    <p>{{ 'APP_SERVICE_WORKER_UPDATE_DESCRIPTION' | translate }}</p>
    <button type="button" class="btn btn-default" (click)="postponeUpdate()">
        {{ 'APP_SERVICE_WORKER_UPDATE_POSTPONE' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="performUpdate()">
        {{ 'APP_SERVICE_WORKER_UPDATE_CONFIRM' | translate }}
    </button>
</div>
